import type { PostHog } from "posthog-js";

/**
 * Identify a patient in PostHog.
 *
 * A patient's distinct_id is ALWAYS their email so pre-auth intake events and
 * post-auth events land on a single Person. Identifying on any other id (the
 * Cognito sub, a username) forks the patient into a second Person mid-flow.
 * Routing every patient identify through here keeps that invariant from
 * drifting between call sites.
 *
 * No-ops when email is absent rather than falling back to another id — a
 * non-email distinct_id is exactly the fork this guards against. Analytics is a
 * best-effort side effect, so failures are logged, never thrown.
 */
export const identifyPatient = (
  posthog: PostHog,
  email: string | undefined,
  properties?: Record<string, unknown>
): void => {
  if (!email) return;
  try {
    posthog.identify(email, { email, ...properties });
  } catch (error) {
    console.error("Error identifying patient in PostHog", error);
  }
};
